/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import React, { useState, useRef } from 'react';
import ReactPlayer from 'react-player/youtube';
import Box from '@mui/material/Box';
import styles from './VideoPlayer.module.scss';
import pauseIcon from '../public_editorcontent/pause-button.svg';
import playIcon from '../public_editorcontent/play-button.svg';
import { analyticsTrack } from '../analytics_utils';
import { PearlUser } from '../Login/userSlice';
interface VideoComponentProps {
  url: string;
  title: string;
  pearlUserInfo?: PearlUser | undefined;
}

const VideoComponent = ({ url, title, pearlUserInfo }: VideoComponentProps) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const playerRef = useRef<any>(null); //It will hold a reference to the ReactPlayer instance, allowing direct manipulation of the player.
  const hasPlayedOnce = useRef(false);

  // Function to toggle play/pause
  const togglePlayPause = () => {
    if (playerRef.current) {
      //checks if the player reference exists
      setIsPlaying((prev) => !prev);
    }
  };
  const handlePlay = () => {
    setIsPlaying(true);
    if (!hasPlayedOnce.current) {
      analyticsTrack('musc_welcomepage_video_played', { url, title }, pearlUserInfo);
      hasPlayedOnce.current = true;
    }
  };
  return (
    <Box
      className={styles.videoContainer}
      onMouseEnter={() => setIsHovered(true)} // Show button on hover
      onMouseLeave={() => setIsHovered(false)} // Hide button on mouse leave
    >
      <span style={{ fontSize: '14px' }}>{title}</span>
      {/* ReactPlayer renders YouTube video */}
      <ReactPlayer
        ref={playerRef}
        url={url}
        controls={true}
        playing={isPlaying}
        width="100%"
        height="100%"
        onPlay={handlePlay}
        onPause={() => setIsPlaying(false)}
      />

      {/* Custom play/pause button overlay */}
      {(isHovered || !isPlaying) && (
        <button onClick={togglePlayPause} className={styles.playPauseButton} data-testid="custom-play-pause">
          <img
            src={isPlaying ? pauseIcon : playIcon}
            alt={isPlaying ? 'Pause' : 'Play'}
            style={{
              width: isPlaying ? '30px' : '25px',
              height: '30px',
              marginTop: '9px',
              marginLeft: isPlaying ? '0' : '5px',
            }}
          />
        </button>
      )}
    </Box>
  );
};

export default VideoComponent;
